import { render, staticRenderFns } from "./LevyCalculationPanelNetProfitRatio.vue?vue&type=template&id=54fe2938&"
import script from "./LevyCalculationPanelNetProfitRatio.vue?vue&type=script&lang=js&"
export * from "./LevyCalculationPanelNetProfitRatio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports